import React from 'react'
import css from '../Marketing Compliance/style.module.css'

export default function HeaderMarketing() {
    return (
        <div className={`container-fluid ${css.documetContainer} py-1`}>
            <div className="row">
                <div className="col-md-12 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="skeleton-text" style={{ width: 200, height: 24, backgroundColor: 'var(--hairline)' }}></div>
                        <div className="ms-2 skeleton-circle" style={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: 'var(--hairline)' }}></div>
                    </div>
                    <div className="d-flex">
                        <div className="skeleton-button me-2" style={{ width: 100, height: 38, backgroundColor: 'var(--hairline)', borderRadius: '4px' }}></div>
                        <div className="skeleton-button me-2" style={{ width: 140, height: 38, backgroundColor: 'var(--hairline)', borderRadius: '4px' }}></div>
                        <div className="skeleton-button" style={{ width: 120, height: 38, backgroundColor: 'var(--hairline)', borderRadius: '4px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
